import { Navigate, Outlet } from 'react-router-dom';
import { authStore } from '../store/auth';

export default function ProtectedRoute() {
  return authStore.token ? <Outlet/> : <Navigate to="/login" replace />;
}
